<script lang="ts" setup>
import { onMounted, ref, watch } from 'vue'
import { useLocalStorage } from '@vueuse/core'
import { api } from '@/api'
import { getToday } from '@/utils'
import { $log } from '@/helpers'
import { KS } from '@/kuaishou'
import { useConfigStore, useLoadingStore, useToastStore } from '@/stores'
import { STORAGE_DAILY_DOUBLE_READ_REWARD } from '@/constants'
import { track } from '@/track'

withDefaults(defineProps<{
  value: boolean
  coin: number
  closable?: boolean
}>(), {
  closable: true,
})
const emit = defineEmits<{
  (event: 'input', value: boolean): void
}>()

const { $toast } = useToastStore()
const { $showLoading, $hideLoading } = useLoadingStore()
const configStore = useConfigStore()

const showDoubleReadReward = useLocalStorage(STORAGE_DAILY_DOUBLE_READ_REWARD, { date: getToday(), times: 0 })
// FIXME: `showDoubleReadReward` don't reactive
function showDoubleReadRewardPlusOne() {
  localStorage.setItem(STORAGE_DAILY_DOUBLE_READ_REWARD,
    JSON.stringify({
      date: getToday(), times: showDoubleReadReward.value.times + 1,
    }),
  )
}
onMounted(() => {
  if (showDoubleReadReward.value.date !== getToday())
    showDoubleReadReward.value = { date: getToday(), times: 0 }
})

const modal = ref(true)
const againCoin = ref(0)
onMounted(async () => {
  try {
    const { data } = await api.post('/kuaishou/ad/inspireNovelAbTest', ['col_reading_process_double_reward'])
    const parts = data.abResult.col_reading_process_double_reward.split('&')
    const params: Record<string, string> = {}
    for (const part of parts) {
      const [key, value] = part.split('=')
      params[key] = value
    }
    if (!params.gold)
      throw new Error('missing `gold` value')
    againCoin.value = Number(params.gold)
  }
  catch (error) {
    $log('Component: BizModalWelfare', '#onMounted', { error })
    againCoin.value = configStore.$state.readDailyInspireDoubleCoin
  }
})

const adVideoPlayer = ref(false)
const adVideoData = ref<{ sessionId: string; src: string; poster: string; isDownload: boolean; [key: string]: any }>({ sessionId: '', src: '', poster: '', isDownload: false })
async function onReceive() {
  $log('Component: BziModalCoin', '#onReceive')
  $showLoading()
  try {
    track('inspireVideo', { name: 'doubleReward', type: 'start' })
    await KS.playAdVideo({
      type: 3,
      extParams: {
        scene: 'colReadTask',
      },
      success(data: any) {
        track('inspireVideo', { name: 'doubleReward', type: 'end' })
        $log('Component: BziModalCoin', '#onReceive ~> success', { data })
        $toast('看完广告视频, 金币领取成功')
        showDoubleReadRewardPlusOne()
        emit('input', false)
      },
      fail(error: any) {
        track('inspireVideo', { name: 'doubleReward', type: 'cancel' })
        $log('Component: BziModalCoin', '#onReceive ~> fail', { error })
        $toast('未看完视频，红包飞走了')
        emit('input', false)
      },
    })
    // modal.value = false
  }
  catch {}
  finally {
    $hideLoading()
  }
}

watch(() => [modal.value, adVideoPlayer.value], () => {
  if (!modal.value && !adVideoPlayer.value)
    emit('input', false)
})

function onCancelAdVideo() {
  $toast('未看完视频，红包飞走了')
}
function onEndAdVideo() {
  $toast('看完广告视频, 金币领取成功')
  emit('input', false)
}
</script>

<template>
  <portal to="root" :order="10">
    <transition name="fade">
      <BizTrackShow
        v-if="modal"
        name="readTaskReward" type="modal" :extra="{ coin }"
        class="fixed inset-0 z-99"
      >
        <div class="fixed inset-0 bg-#000000B2" @click="closable && $emit('input', false)" />
        <div
          class="w-270px px-30px pt-50px pb-25px
            absolute top-1/2 left-1/2 -translate-1/2
            rounded-15px rounded-tr-50px bg-white z-100 relative
          "
        >
          <img class="w-125px absolute -top-62px right-0" src="@/assets/modal-label-coin.png">
          <p>恭喜获得阅读奖励</p>
          <p class="flex items-baseline space-x-2 text-primary font-bold">
            <span class="text-60px">{{ coin === 0 ? '...' : coin }}</span>
            <span class="relative -top-2 ">金币</span>
          </p>
          <div v-if="showDoubleReadReward.times < configStore.$state.readDailyInspireDoubleNumMax">
            <a
              class="block w-full py-2 text-center text-white bg-primary rounded-full"
              @click="onReceive"
            >
              看完视频, 再领{{ againCoin }}金币
            </a>
          </div>
        </div>
      </BizTrackShow>
    </transition>

    <!-- <BizAdVideoPlayer
      v-if="adVideoPlayer"
      v-model="adVideoPlayer" :session-id="adVideoData.sessionId"
      :src="adVideoData.src" :poster="adVideoData.poster" :caption="adVideoData.caption"
      :is-download="adVideoData.isDownload" :action-bar="adVideoData.actionBar" :action-bar-color="adVideoData.actionBarColor"
      @end="onEndAdVideo" @cancel="onCancelAdVideo"
    /> -->
  </portal>
</template>
